import { useState } from 'react';
import appConstants from '../../../../constants';
import { KEYS } from '../../../../l18n/constants';
import { selectFilterValue } from '../../helpers';

// "SORT_ORDER": "DESC",
// "SORT_BY":"badge_rank",

const defaults = Object.freeze({
  initialSelectedSortingParameterValue : appConstants.SORTING_PARAMETER_DEFAULT,
  sortingLookupValues : [
    {
      [appConstants.KEY_NAME]: KEYS.L18N_KEY_LABEL_PARTNER_LEVEL,
      [appConstants.KEY_CODE]:'Partner Level',
      [appConstants.KEY_IS_SELECTED]: true,
      [appConstants.KEY_IS_DISABLED]: false,
      [appConstants.KEY_TYPE]: appConstants.VALUE_SORTING,
      [appConstants.KEY_SUBTYPE]: appConstants.VALUE_SORTING,
      [appConstants.KEY_ORIGINAL_DATA]: {
        [appConstants.KEY_SORT_BY]: appConstants.SORT_BY_BADGE_RANK,
        [appConstants.KEY_SORT_ORDER]: appConstants.SORT_ORDER_ASC
      }
    },
    {
      [appConstants.KEY_NAME]:KEYS.L18N_KEY_LABEL_ALPHABETICAL,
      [appConstants.KEY_CODE]:'Alphabetical',
      [appConstants.KEY_IS_SELECTED]: false,
      [appConstants.KEY_IS_DISABLED]: false,
      [appConstants.KEY_TYPE]: appConstants.VALUE_SORTING,
      [appConstants.KEY_SUBTYPE]: appConstants.VALUE_SORTING,
      [appConstants.KEY_ORIGINAL_DATA]: {
        [appConstants.KEY_SORT_BY]: appConstants.SORT_BY_PARTNER_NAME,
        [appConstants.KEY_SORT_ORDER]: appConstants.SORT_ORDER_ASC
      }
    },
    {
      [appConstants.KEY_NAME]:KEYS.L18N_KEY_LABEL_DIVERSE_PARTNER,
      [appConstants.KEY_CODE]:'Diverse Partner',
      [appConstants.KEY_IS_SELECTED]: false,
      [appConstants.KEY_IS_DISABLED]: false,
      [appConstants.KEY_TYPE]: appConstants.VALUE_SORTING,
      [appConstants.KEY_SUBTYPE]: appConstants.VALUE_SORTING,
      [appConstants.KEY_ORIGINAL_DATA]: {
        [appConstants.KEY_SORT_BY]: appConstants.SORT_BY_DIVERSE_PARTNER,
        [appConstants.KEY_SORT_ORDER]: appConstants.SORT_ORDER_ASC
      }
    },
  ]
});

//const defaults = Object.freeze(
//  {
//    initialSelectedSortingParameterValue : appConstants.SORTING_PARAMETER_DEFAULT,
//    sortingLookupValues : [
//      Object.fromEntries(
//        new Map([
//          [appConstants.KEY_NAME, 'Rank up'],
//          [appConstants.KEY_CODE, 'Rank up'],
//          [appConstants.KEY_IS_SELECTED, false],
//          [appConstants.KEY_IS_DISABLED, false],
//          [appConstants.KEY_TYPE, appConstants.VALUE_SORTING],
//          [appConstants.KEY_SUBTYPE, appConstants.VALUE_SORTING],
//          [appConstants.KEY_ORIGINAL_DATA, Object.fromEntries(new Map([
//            [appConstants.KEY_SORT_BY, appConstants.SORT_BY_BADGE_RANK],
//            [appConstants.KEY_SORT_ORDER, appConstants.SORT_ORDER_ASC]
//          ]))]
//        ])),
//      Object.fromEntries(
//        new Map([
//          [appConstants.KEY_NAME, 'Rank down'],
//          [appConstants.KEY_CODE, 'Rank down'],
//          [appConstants.KEY_IS_SELECTED, false],
//          [appConstants.KEY_IS_DISABLED, false],
//          [appConstants.KEY_TYPE, appConstants.VALUE_SORTING],
//          [appConstants.KEY_SUBTYPE, appConstants.VALUE_SORTING],
//          [appConstants.KEY_ORIGINAL_DATA, Object.fromEntries(new Map([
//            [appConstants.KEY_SORT_BY, appConstants.SORT_BY_BADGE_RANK],
//            [appConstants.KEY_SORT_ORDER, appConstants.SORT_ORDER_DESC]
//          ]))]
//        ])),
//      Object.fromEntries(
//        new Map([
//          [appConstants.KEY_NAME, 'Name up'],
//          [appConstants.KEY_CODE, 'Name up'],
//          [appConstants.KEY_IS_SELECTED, false],
//          [appConstants.KEY_IS_DISABLED, false],
//          [appConstants.KEY_TYPE, appConstants.VALUE_SORTING],
//          [appConstants.KEY_SUBTYPE, appConstants.VALUE_SORTING],
//          [appConstants.KEY_ORIGINAL_DATA, Object.fromEntries(new Map([
//            [appConstants.KEY_SORT_BY, appConstants.SORT_BY_PARTNER_NAME],
//            [appConstants.KEY_SORT_ORDER, appConstants.SORT_ORDER_ASC]
//          ]))]
//        ])),
//      Object.fromEntries(
//        new Map([
//          [appConstants.KEY_NAME, 'Name down'],
//          [appConstants.KEY_CODE, 'Name down'],
//          [appConstants.KEY_IS_SELECTED, false],
//          [appConstants.KEY_IS_DISABLED, false],
//          [appConstants.KEY_TYPE, appConstants.VALUE_SORTING],
//          [appConstants.KEY_SUBTYPE, appConstants.VALUE_SORTING],
//          [appConstants.KEY_ORIGINAL_DATA, Object.fromEntries(new Map([
//            [appConstants.KEY_SORT_BY, appConstants.SORT_BY_PARTNER_NAME],
//            [appConstants.KEY_SORT_ORDER, appConstants.SORT_ORDER_DESC]
//          ]))]
//        ])),
//    ]
//  }
//);

export default function useSortingParameter(initialSelectedSortingParameterValue = defaults.initialSelectedSortingParameterValue) {
  function initializeSortingParameterValues() {
    return () => defaults.sortingLookupValues.map(
      (lookupValue) => {
        let updatedLookupValue = {...lookupValue};
        if (
          (lookupValue[appConstants.KEY_ORIGINAL_DATA][appConstants.KEY_SORT_BY] === initialSelectedSortingParameterValue[appConstants.KEY_SORT_BY]) &&
          (lookupValue[appConstants.KEY_ORIGINAL_DATA][appConstants.KEY_SORT_ORDER] === initialSelectedSortingParameterValue[appConstants.KEY_SORT_ORDER])
        ) {
          updatedLookupValue[appConstants.KEY_IS_SELECTED] = true;
        }
        return updatedLookupValue;
      }
    );
  }

  const [isSortingParameterDropdownOpened, setIsSortingParameterDropdownOpened] = useState(false);
  const [sortingParameterValues, setSortingParameterValues] = useState(initializeSortingParameterValues());
  const [selectedSortingParameterValue, setSelectedSortingParameterValue] = useState(initialSelectedSortingParameterValue);
  //  useState(
  //  Object.fromEntries(new Map([
  //    [appConstants.KEY_SORT_BY, appConstants.SORT_BY_BADGE_RANK],
  //    [appConstants.KEY_SORT_ORDER, appConstants.SORT_ORDER_ASC]
  //  ]))
  //);

  function selectSortingParameterValue(sortingParameterValue) {
    const updateSortingParameterValueOperationResults =
      selectFilterValue(sortingParameterValue, sortingParameterValues);
    if (updateSortingParameterValueOperationResults.areFilterValuesUpdated) {
      setSortingParameterValues(previousValue => [...updateSortingParameterValueOperationResults.updatedFilterValues]);
      let selectedSortingParameterValue = { ...sortingParameterValue };
      selectedSortingParameterValue[appConstants.KEY_IS_SELECTED] = true;
      setSelectedSortingParameterValue(previousValue => selectedSortingParameterValue[appConstants.KEY_ORIGINAL_DATA] );
      setIsSortingParameterDropdownOpened(previousValue => false);
    }
  }

  function toggleSortingParameterDropdown() {
    setIsSortingParameterDropdownOpened(previousValue => !isSortingParameterDropdownOpened);
  }

  return {
    isSortingParameterDropdownOpened,
    sortingParameterValues,
    selectSortingParameterValue,
    selectedSortingParameterValue,
    toggleSortingParameterDropdown
  }
}
